import React from "react"

import { SelectOption } from "shared/types/Select"

export function RJSFFormattedSelectOptionComponent<
  T extends string | number | boolean | null
>({ option }: { option: SelectOption<T> | null | undefined }) {
  if (!option) {
    return null
  }

  const { value, label } = option
  if (value === label) {
    return (
      <div>
        <span>{label}</span>
      </div>
    )
  }
  return (
    <div>
      <span className="font-bold">{value}</span>
      {": "}
      <span>{label}</span>
    </div>
  )
}

export const RJSFFormattedSelectOption = React.memo(
  RJSFFormattedSelectOptionComponent
) as typeof RJSFFormattedSelectOptionComponent
